/**
 * Converts a hex color string (e.g. "#ff0000" or "#f00") to an [r, g, b] tuple.
 * Returns black if the input isn't a valid hex color.
 */
export function hexToRgb(hex: string): [number, number, number] {
  let normalized = hex;
  // Expand short-form hex color if needed (e.g., #f06 -> #ff0066)
  if (normalized?.length === 4) {
    normalized = normalized.replace(/([0-9a-f])/gi, "$1$1");
  }

  const rgb = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(normalized);

  if (rgb) {
    return [parseInt(rgb[1], 16), parseInt(rgb[2], 16), parseInt(rgb[3], 16)];
  }
  return [0, 0, 0];
}
